import { BooleanInput, Create, SimpleForm, TextInput } from "@/components/admin";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { FileText } from "lucide-react";
import { required } from "ra-core";

export const TermsTemplateCreate = () => (
    <Create>
        <SimpleForm className="max-w-4xl mx-auto space-y-6">
            <Card className="w-full shadow-sm">
                <CardHeader className="pb-3 border-b bg-muted/50">
                    <div className="flex items-center gap-2">
                        <FileText className="w-5 h-5 text-primary" />
                        <CardTitle className="text-lg font-semibold tracking-tight">New Terms Template</CardTitle>
                    </div>
                </CardHeader>
                <CardContent className="pt-6 space-y-4">
                    <div className="flex justify-between items-start gap-4">
                        <TextInput source="name" label="Template Name" validate={required()} className="flex-1" />
                        <BooleanInput source="is_default" label="Set as Default" className="mt-2" />
                    </div>
                    <TextInput 
                        source="content" 
                        label="Terms & Conditions Content" 
                        validate={required()} 
                        multiline 
                        rows={12} 
                        className="w-full max-w-none" 
                    />
                </CardContent>
            </Card>
        </SimpleForm>
    </Create>
);
